import React from "react";

export const ALGA_SUCCESS = "success";
export const ALGA_ERROR = "error";
export const ALGA_INFO = "info";

const images = {
  [ALGA_SUCCESS]: "/static/img/algaIcon/alga-success.svg",
  [ALGA_ERROR]: "/static/img/algaIcon/alga-error.svg",
  [ALGA_INFO]: "/static/img/algaIcon/alga-info.svg",
};

const sizes = {
  small: "88",
  medium: "104",
  large: "120",
};

const AlgaIcon = ({ variant, size }: AlgaIconProps) => {
  return (
    <img
      src={images[variant]}
      alt={`alga-${variant}`}
      width={sizes[size]}
      height={sizes[size]}
    />
  );
};

export default AlgaIcon;

export type AlgaVariant =
  | typeof ALGA_SUCCESS
  | typeof ALGA_ERROR
  | typeof ALGA_INFO;
/**
 * This interface defines the properties accepted by the AlgaIcon component.
 * @example
 * // Example usage of the AlgaIcon property
        <AlgaIcon variant={variant} size="large" />
 */
type AlgaIconProps = {
  /**
   * The size of the image.
   */
  size: "small" | "medium" | "large";
  /**
   * The variant of the seaweed image in the information box. It can be "success" for green seaweed,
   * "info" for yellow seaweed, or "error" for red seaweed.
   */
  variant: AlgaVariant;
};
